<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vWFRtk/tc-custom/9780830886005.jpg?1696870394451" alt="This image is the cover for the book Evangelical Theological Method, Spectrum Multiview Book Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evangelical Theological Method, Spectrum Multiview Book Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>How should one approach the task of theology?</strong> The question of methodology is increasingly one of interest among theologians, who recognize that the very manner in which we approach theology informs both the questions we ask and the conclusions we reach.</p> <p>This volume in IVP's Spectrum Multiview series brings together five evangelical theologians with distinctly different approaches to the theological task. After presenting the approaches—which include appeals to Scripture, context, missions, interdisciplinary studies, and dogmatics—each contributor responds to the other views.</p> <p>Emerging from this theological conversation is an awareness of our methodological commitments and the benefits that each approach can bring to the theological task.</p> <p> <strong>Contributors:</strong> </p>  Sung Wook Chung John R. Franke Telford C. Work Victor Ifeanyi Ezigbo Paul Louis Metzger  <p>Spectrum Multiview Books offer a range of viewpoints on contested topics within Christianity, giving contributors the opportunity to present their position and also respond to others in this dynamic publishing format.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stanley E. Porter, Steven M. Studebaker
      </h2>
      
      <p class="authorDescription body article"><p>Stanley E. Porter (PhD, University of Sheffield) is president, dean, professor of New Testament, and Roy A. Hope Chair in Christian Worldview at McMaster Divinity College in Hamilton, Ontario, Canada. He is the author of twenty-eight books on various topics in New Testament and related subjects, including <em>Hermeneutics: An Introduction to Interpretive Theory</em> (with Jason C. Robinson), and he has edited over eighty volumes, including <em>Biblical Hermeneutics: Five Views</em> (with Beth M. Stovell). Porter has also published over three hundred articles, chapters, and related writings.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d61f688